// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1yW7D","title":"Info_title__3X3Ir","links":"Info_links__3wPcR","link":"Info_link__3cL1W","logo":"Info_logo__1P7ut"};